import Vue from 'vue';

const success = (context, response) => {
  context.user.booking_statuses = response.data.booking_statuses;
  context.user.rights = response.data.rights;
  context.user.is_team_member = response.data.is_team_member;
  context.loading = false;
};

const failed = (context, error) => {
  context.loading = false;
};

export default (context) => {
  return Vue.$http.get('get-user-statuses')
    .then((response) => {
      if (response && response.status === 200) {
        success(context, response);
      }
    }).catch((error) => {
      failed(context, error);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/account/getUserWithStatuses.js